/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import {
    fetchCampingSearch,
    fetchTicketSearch,
    fetchPOISearch,
    fetchGatewaySearch,
    fetchActivityPassesSearch,
    fetchTreePermitsSearch,
    fetchVenueReservationSearch,
    fetchVenueFacilitySearch,
} from './redux/reducers/fetchSearch';

export const newGatewayReducers = combineReducers({
    fetchCampingSearch,
    fetchTicketSearch,
    fetchPOISearch,
    fetchGatewaySearch,
    fetchTreePermitsSearch,
    fetchVenueReservationSearch,
    fetchVenueFacilitySearch,
    fetchActivityPassesSearch,
});
